module.exports = __webpack_public_path__ + "img/popup_attachment.cd11bb9c.svg";